import { isArray, keys } from '@frontend/duck-tape';
import type { FormikErrors } from 'formik';
import type { ZodError } from 'zod';

export const flattenErrors = <TValues, TErrorMap extends FormikErrors<TValues>>(errors: TErrorMap) => {
  return keys(errors).reduce(
    (acc, cur) => {
      const value = errors[cur];
      if (isArray(value)) {
        return { [cur]: value.join(','), ...acc };
      }
      return { [cur]: value, ...acc };
    },
    {} as Record<keyof TErrorMap, MaybeUndefined<string>>,
  );
};

export type ZodErrorMap<TValues extends GenericRecord> = Record<keyof TValues, string>;

export const makeErrorsMapFromValidation = <TValues extends GenericRecord>(validationResult: ZodError<TValues>) =>
  validationResult.errors.reduce((acc, issue) => {
    const field = issue.path[0] as keyof TValues;
    if (!field || field in acc) return acc;
    return { ...acc, [field]: issue.message };
  }, {} as ZodErrorMap<TValues>);
